import classNames from "classnames";
import {FjdHeading, FjdIcon, FjdModal, FjdStack} from "@efast/fjd-react-components";
import {Certificate, ErrorTypes} from "../../model/Certificate";
import CertificateAuthority from "./CertificateAuthority";
import CertificateUser from "./CertificateUser";
import useOfflineHook from "../../hooks/offlineHook";
import txt from "./../../content.json";
import "./CertificateConfirmationModal.css";

export interface CertificateValidatedProps {
    onClose?: (event: React.KeyboardEvent<Element> | React.MouseEvent<Element, MouseEvent>) => void;
    onScanClick?: React.MouseEventHandler<Element>;
    certificate?: Certificate;
    open?: boolean;
    loading?: boolean;
    errorType?: ErrorTypes;
    isTest: boolean;
}

function CertificateConfirmationModal({
                                          onClose,
                                          open,
                                          certificate,
                                          onScanClick,
                                          loading,
                                          errorType,
                                          isTest
                                      }: CertificateValidatedProps) {
    const isAppOffline = useOfflineHook();

    const backgroundClass = classNames("certificate-validated-modal__icon-wrap__background", {
        "certificate-validated-modal__icon-wrap__background--red": certificate?.valid === false,
        "certificate-validated-modal__icon-wrap__background--green": certificate?.valid === true,
        "certificate-validated-modal__icon-wrap__background--gray": loading
    });

    const cert = txt.certificateValidateModal.certificate;
    const isValid = certificate?.valid ? txt.certificateValidateModal.valid : txt.certificateValidateModal.invalid;

    // @ts-ignore
    // @ts-ignore
    return (
        <FjdModal
            appElement={document.getElementById("root") as HTMLElement}
            loading={loading}
            primaryButtonLabel={txt.certificateValidated.btnScanMore}
            primaryButtonDisabled={isAppOffline}
            onPrimaryButtonClick={onScanClick}
            closeOnBackdropClick={true}
            closable={true}
            // width="fullscreen"
            onClose={onClose}
            open={open}
            heading=""
        >
            <FjdStack className="certificate-validated-modal" spacing="xxl">
                <FjdStack className="certificate-validated-modal__icon-wrap">
                    <div className={backgroundClass}>

                        {certificate?.valid ? (
                            <FjdIcon appearance="success" glyph="thumbs-up" size="xxl"></FjdIcon>
                        ) : (
                            <>
                                {loading ? (
                                    <FjdIcon glyph="renew" size="xxl"></FjdIcon>
                                ) : (
                                    <FjdIcon appearance="error" glyph="thumbs-down" size="xxl"></FjdIcon>
                                )}
                            </>
                        )}
                    </div>
                </FjdStack>
                <FjdStack>
                    <FjdHeading text={`${cert} ${isValid}`}></FjdHeading>
                    {isTest && <strong>{txt.certificateValidateModal.isTest}</strong>}
                    {certificate?.valid ? (
                        <p>{txt.certificateValidateModal.isValidConfirmData}</p>
                    ) : (
                        <p>{txt.certificateValidateModal.isInvalidInformation}</p>
                    )}
                </FjdStack>
                <FjdStack className="certificate-validated-modal__info-wrap">
                    {certificate?.valid ? (
                        <FjdStack spacing="l">
                            <CertificateUser certificate={certificate}></CertificateUser>
                            <CertificateAuthority certificate={certificate}></CertificateAuthority>
                        </FjdStack>
                    ) : (
                        <FjdStack spacing="l">
                            {errorType === ErrorTypes.cert ? (
                                <p>
                                    <strong>{txt.certificateValidateModal.isInvalidSignature}</strong>
                                    <br/>
                                    <span>{txt.certificateValidateModal.isInvalidSignatureDescription}</span>
                                </p>
                            ) : errorType === ErrorTypes.qrcode ? (
                                <p>
                                    <strong>{txt.certificateValidateModal.isInvalidQrcode}</strong>
                                    <br/>
                                    <span>{txt.certificateValidateModal.isInvalidQrcodeDescription}</span>
                                </p>
                            ) : errorType === ErrorTypes.server ? (
                                <p>
                                    <strong>{txt.certificateValidateModal.isInvalidServerError}</strong>
                                    <br/>
                                    <span>{txt.certificateValidateModal.isInvalidServerErrorDescription}</span>
                                </p>
                            ) : (
                                <p>
                                    <strong>{txt.certificateValidateModal.unknownError}</strong>
                                </p>
                            )}
                        </FjdStack>
                    )}
                </FjdStack>
            </FjdStack>
        </FjdModal>
    );
}

export default CertificateConfirmationModal;
